const base_url = process.env.REACT_APP_BASE_URL;
const buildUrl = (path) => `${base_url}${path}`;

const api = {
  login: `${base_url}/auth/login`,
  verifyOtp: `${base_url}/auth/login/verify-otp`,
  registration: `${base_url}/api/v1/users/invite`,
  resendActivationLink: `${base_url}/api/v1/users/resend-activation-link`,
  sendOtp: `${base_url}/auth/users/sendOtp`,
  resendOtp: `${base_url}/auth/users/resendOtp`,
  validateOtp: `${base_url}/auth/users/validate/otp`,
  getAllUsers: `${base_url}/api/v1/users`,
  getUserById: `${base_url}/api/v1/users/`,
  updateInviteCandidate: `${base_url}/api/v1/users/updateInviteUser`,
  invitedusers: `${base_url}/auth/invited/users/`,
  getPartialCandidateData: `${base_url}/api/v1/users/partial`,
  getInvitedUserDetailsById: `${base_url}/auth/invited/users/`,
  updateCandidateStatus: `${base_url}/api/v1/users/invited/update/status`,
  getInvitedActivity: `${base_url}/api/v1/users/invited/activity/`,
  forgotpassword: `${base_url}/auth/forgot-password`,
  resetPassword: `${base_url}/auth/reset-password`,
  logout: `${base_url}/auth/logout`,
  searchCandidateAndEmployee: `${base_url}/api/v1/search/`,
  getDropdownList: `${base_url}/api/v1/config/getTypeList`,
  verifyToken: `${base_url}/auth/invite/verify-token?token=`,
  updateJoiningDetails: `${base_url}/api/v1/users/joining-details/`,
  employeeChangePassword: `${base_url}/api/v1/employee/change-password/`,
  postPolicyAcceptApi: `${base_url}/api/v1/policies/accept`,
  policies: `${base_url}/api/v1/policies`,
  getPolicyActiveApi: `${base_url}/api/v1/policies/active`,
  uploadPreOnboardingDocs: `${base_url}/auth/files/upload`,
  getPreOnboardingDocsById: `${base_url}/auth/files/download`,
  myProfile: `${base_url}/api/v1/users/my/profile`,
  updateEmployeeRole: `${base_url}/api/v1/roles/updateEmployeeRole?`,
  dashboardChartKpi: `${base_url}/api/v1/dashboard/kpi`,
  updateEmployeeDetails: `${base_url}/api/v1/users/employee/`,
  resendWelcomeMail: `${base_url}/api/v1/employee/resend-welcome-mail/`,
  updateAccountStatus: `${base_url}/api/v1/employee/update/account/status/`,
  getExportData: `${base_url}/api/v1/employee/export/insurance-dependent-details/`,
  getExportCandidateData: `${base_url}/api/export/candidate`,
  getExportEmployeeData: `${base_url}/api/export/employee`,
  existingEmployee: `${base_url}/api/v1/users/existing-employee`,
  approveExistingEmp: `${base_url}/api/migration/employees/approve`,
  deleteExistingEmp: `${base_url}/api/migration/employees/delete/`,

  holidays: {
    upcomingHoliday: `${base_url}/api/holiday/upcoming`,
    getAllHoliday: `${base_url}/api/holiday/all?year=`,
    updateHoliday: `${base_url}/api/holiday/`,
    createHoliday: `${base_url}/api/holiday/add`,
    publishHoliday: `${base_url}/api/holiday/publish?year=`,
    deleteHoliday: `${base_url}/api/holiday/delete/`,
    HRViewHoliday: `${base_url}/api/holiday/hr/view?year=`,
    getHolidayById: `${base_url}/api/holiday/`,
    getListOfCalendar: `${base_url}/api/holiday/hr/calendarList`,
  },

  permissions: {
    create: `${base_url}/api/v1/permissions`,
    getAll: `${base_url}/api/v1/permissions`,
    getById: `${base_url}/api/v1/permissions/`,
    getLoggedIn: `${base_url}/api/v1/users/permissions`,
    update: `${base_url}/api/v1/permissions`,
    delete: `${base_url}/api/v1/permissions`,
    assign: `${base_url}/api/v1/users/add-permission`,
    remove: `${base_url}/api/v1/users/remove-permission`,
  },

  roles: {
    getAll: buildUrl("/api/v1/roles"),
    create: buildUrl("/api/v1/roles"),
    update: (id) => buildUrl(`/api/v1/roles/${id}`),
    delete: (id) => buildUrl(`/api/v1/roles/${id}`),
    getById: buildUrl("/api/v1/roles/"),
  },

  configuration: {
    create: `${base_url}/api/v1/config`,
    update: `${base_url}/api/v1/config`,
    getById: `${base_url}/api/v1/config`,
    getAll: `${base_url}/api/v1/config`,
    delete: `${base_url}/api/v1/config`,
  },

  credentials: {
    workingModeShift: `${base_url}/api/v1/config/default/dropdown/values`,
    // designation: `${base_url}/api/v1/config/designation/values`,
    // department: `${base_url}/api/v1/config/department/values`,
    designation: `${base_url}/api/v1/designations`,
    department: `${base_url}/api/v1/departments`,
    allActiveEmp: `${base_url}/api/v1/users/dropdown/getAllActiveEmployee`,
    create: `${base_url}/api/v1/employee/convert-to-employee`,
  },

  filesUpload: {
    create: `${base_url}/api/v1/files/upload`,
    getSingleFile: `${base_url}/api/v1/files/download`,
    getAllFiles: `${base_url}/api/v1/files/getFilesByUserId`,
  },

  announcements: {
    getAll: `${base_url}/api/v1/announcements`,
    getById: `${base_url}/api/v1/announcements/`,
    getPublished: `${base_url}/api/v1/announcements/published`,
    getComments: (id) => `${base_url}/api/v1/announcements/${id}/comments`,
  },

  departments: {
    getAll: `${base_url}/api/v1/departments`,
    getById: `${base_url}/api/v1/departments/`,
    activate: `${base_url}/api/v1/departments/activate-department/`,
    deactivate: `${base_url}/api/v1/departments/inactivate-department/`,
    getPublished: `${base_url}/api/v1/departments/published`,
  },

  designations: {
    getAll: `${base_url}/api/v1/designations`,
    getById: `${base_url}/api/v1/designations/`,
    activate: `${base_url}/api/v1/designations/activate-department/`,
    deactivate: `${base_url}/api/v1/designations/inactivate-department/`,
    getPublished: `${base_url}/api/v1/designations/published`,
  },

  support: {
    createTicket: `${base_url}/api/v1/support/tickets`,
    getTicketById: (id) => `${base_url}/api/v1/support/tickets/${id}`,
    getMyTickets: () => `${base_url}/api/v1/support/tickets/my`,
    getAllTickets: () => `${base_url}/api/v1/support/tickets`,
    getAllCategories: () => `${base_url}/api/v1/support/admin/categories`,

    /* ================= ATTACHMENTS ================= */
    attachDoc: (id) => `${base_url}/api/v1/support/tickets/${id}/attachments`,
    getDoc: (id) => `${base_url}/api/v1/support/tickets/${id}/attachments/download`,
    /* ================= COMMENTS ================= */
    addComment: (id) => `${base_url}/api/v1/support/tickets/${id}/comments`,
    /* ================= REASSIGN ================= */
    reAssignTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/reassign`,
    getAssignmentUsers: () => `${base_url}/api/v1/support/admin/assignments`,
    /* ================= TICKET ACTIONS ================= */
    markProcessing: (id) => `${base_url}/api/v1/support/tickets/${id}/processing`,
    approveTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/approve`,
    partialApproveTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/partial-approve`,
    rejectTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/reject`,
    verifyTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/verify`,
    reworkTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/rework`,
    closeTicket: (id) => `${base_url}/api/v1/support/tickets/${id}/close`,
    escalateTicket: (id) => `/api/v1/support/tickets/${id}/escalate`,
    /* ================= PROFILE UPDATE ================= */
    submitProfileData: (id) => `${base_url}/api/v1/support/tickets/${id}/profile-update/staging`,
    getProfileDiffData: (id) => `${base_url}/api/v1/support/tickets/${id}/profile-update/diff`,
    getProfileData: (id) => `${base_url}/api/v1/support/tickets/${id}/profile-update/staging`,
  },

  supportConfig: {
    createSupportConfig: `${base_url}/api/v1/support/admin/config`,
    getAllSupportConfig: `${base_url}/api/v1/support/admin/config`,
    createHRAssignment: `${base_url}/api/v1/support/admin/assignments`,
    getAllHRAssignment: `${base_url}/api/v1/support/admin/assignments`,
  }

}

export default api;
